import { BottomSheet } from '@new-components/elements';

import { MissingInputValidationProps } from './types';
import FailedVerificationImage from '@assets/illustrations/failed-verification.png';
import { missingInputValidationCx } from './styles';
import { Typography } from '@julo-ui/react';

const MissingInputValidation = (props: MissingInputValidationProps) => {
  const { onClose, isOpen } = props;

  return (
    <BottomSheet
      title='Isi Informasi Rekening Kamu, Yuk!'
      display={isOpen}
      onClose={onClose}
      ctaText='Kembali'
    >
      <div className={missingInputValidationCx}>
        <img
          src={FailedVerificationImage}
          alt='Verifikasi Gagal'
          className='illustration'
        />
        <Typography type='body' fontSize='16px' sx={{ marginBottom: '16px' }}>
          Sebelum ubah pinjaman, isi informasi rekening kamu dulu, ya!
        </Typography>
      </div>
    </BottomSheet>
  );
};

export default MissingInputValidation;
